import React from 'react';
import AppHeader from './AppHeader';
import Footer from './Footer';

export default function AppShell({ children }) {
  return (
    <div className="lc-shell">
      <AppHeader />
      <main className="lc-shell__main">{children}</main>
      <Footer />
    </div>
  );
}
